const urlBase64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')

  const rawData = window.atob(base64)
  const outputArray = new Uint8Array(rawData.length)

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i)
  }

  return outputArray
}

const initialiseState = () => {
  // Are Notifications supported in the service worker?
  if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
    return
  }

  // Safari already have the serviceWorkerRegistration methods but do not Notification
  if (typeof Notification === 'undefined') {
    return
  }

  // Check the current Notification permission.
  // If its denied, it's a permanent block until the
  // user changes the permission
  if (Notification.permission === 'denied') {
    return
  }

  // Check if push messaging is supported
  if (!('PushManager' in window)) {
    return
  }

  // We need the service worker registration to check for a subscription
  navigator.serviceWorker.ready.then(function (serviceWorkerRegistration) {
    // Do we already have a push message subscription?
    serviceWorkerRegistration.pushManager
      .getSubscription()
      .then(function (subscription) {
        if (!subscription) {
          return
        }
        localStorage.subscription = JSON.stringify(subscription)
      })
      .catch(function (err) {
        console.warn(err)
      })
  })
}
const pwaInitWithNotification = () => {
  getMachineId()
  const channel4Broadcast = new BroadcastChannel('channel4')
  channel4Broadcast.onmessage = (event) => {
    if (event.data.subscription) {
      localStorage.subscription = event.data.subscription
    }
  }

  if (!navigator.serviceWorker) {
    return
  }

  if (!navigator.serviceWorker.controller) {
    navigator.serviceWorker.register('./sw.js').then(initialiseState)
  } else {
    navigator.serviceWorker.ready.then(function (registration) {
      if (!registration.pushManager) {
        return false
      }
      if (!process.env.WEB_NOTIFICATION_PUBLIC_KEY) {
        return false
      }
      // ---to subscribe push notification using pushmanager---
      return registration.pushManager
        .subscribe(
          // ---always show notification when received---
          {
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(process.env.WEB_NOTIFICATION_PUBLIC_KEY),
          }
        )
        .then(function (subscription) {
          if (subscription) {
            localStorage.subscription = JSON.stringify(subscription)
          }
        })
        .catch(function (e) {
          localStorage.removeItem('subscription')
          if (Notification.permission === 'denied') {
            // The user denied the notification permission which
            // means we failed to subscribe and the user will need
            // to manually change the notification permission to
            // subscribe to push messages
          } else {
            // A problem occurred with the subscription; common reasons
            // include network errors, and lacking gcm_sender_id and/or
            // gcm_user_visible_only in the manifest.
            console.error('Unable to subscribe to push.', e)
          }
        })
    })
  }
}

const getMachineId = () => {
  let machineId = localStorage.getItem('browserID')

  if (!machineId) {
    try {
      machineId = crypto.randomUUID()
    } catch (e) {
      const time = Date.now()
      const unique = Math.random().toString(36).substring(2, 10)
      machineId = `${time}-${unique}`
    }

    localStorage.setItem('browserID', machineId)
  }

  return machineId
}

export default pwaInitWithNotification
